import { render, staticRenderFns } from "./editWarehouse.vue?vue&type=template&id=656f6dc2&scoped=true&"
import script from "./editWarehouse.vue?vue&type=script&lang=js&"
export * from "./editWarehouse.vue?vue&type=script&lang=js&"
import style0 from "./editWarehouse.vue?vue&type=style&index=0&id=656f6dc2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656f6dc2",
  null
  
)

export default component.exports